export default "__VITE_ASSET__DdSDNKDW__"